// extracted by mini-css-extract-plugin
export var fullHeightState = "_47-7";
export var headerCell = "_47-1";
export var loadingStateCell = "_47-4";
export var rowWrapper = "_47-3";
export var standaloneTable = "_47-8";
export var standaloneTableWithBodyFill = "_47-9";
export var stateCell = "_47-5";
export var table = "_47-0";
export var tableBodyFiller = "_47-6";
export var white = "_47-2";